import { compose, withState } from 'recompose'

const ToggleSectionContainer = compose(withState('show', 'setShow', false))

export default ToggleSectionContainer
